export default __webpack_public_path__ + "static/media/hep.0270200b.jpg";